export enum ColumnKeys {
  IbcVolume = 'ibcVolume',
  IbcTransfers = 'ibcTransfers',
  TotalTxs = 'totalTxs',
  Dau = 'dau',
}
